import Icon, { CalendarOutlined, CameraOutlined, CheckCircleTwoTone, ClockCircleTwoTone, ExclamationCircleTwoTone, InfoCircleOutlined, NotificationOutlined, PlayCircleOutlined, SearchOutlined, StarFilled, TagOutlined, TagsOutlined } from '@ant-design/icons';
import { Badge, Divider, Input, Radio, Rate, Tag, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { FilterDropdownProps } from 'antd/lib/table/interface';
import TableLZM from '../../../design/table/TableLZM';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { ColorStar, ColorStarOutlined } from '../../../../../common/utils/ColorStar';
import { Label } from '../../../../pages/menuReviews/3_1_Reviews/Reviews/Label';
import { LocationCardCompacted, LocationTitle } from '../../business/FieldsGroup';
import { getReviewStatus } from '../../../../../common/utils/ReviewUtils';


const Reviews = ({ reviewsData, selectedReview, handleReviewClick, width = '56%', isLoading, onLabelchange }: any) => {

    const { t } = useTranslation();
	
    useEffect(() => {        
        selectedReview && onSelectRow(selectedReview);            
    }, [selectedReview])

    const columns: any = [
        /*{
            title: '',
            key: 'reviewReplyComment',
            dataIndex: 'reviewReplyComment',
            align: 'center',
            width: '40px',
            render: (_: string, record: any) => {
                
                const { Icon, color, tooltip } = getReviewStatus(record);
                return (                    
                    <Icon style={{ fontSize: '18px', color:color }} />
                );
            }
        },*/
        {
            title: 'Nota',
            key: 'starRating',
            width: '50px',
            dataIndex: 'starRating',
            align: 'center',
            render: (text: string, record: any) => {
                
                return (record.starRating &&
                <>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <ColorStarOutlined
                            style={{ fontSize: '18px' }}
                            value={Math.round(10 * record.starRating) / 10}/>
                    </div>                                            
                </>)
            }
        },
        {
            title: 'Reseña',
            key: 'text',
            dataIndex: 'text',
            width: '300px',
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
            }: FilterDropdownProps) => {
                return (                    
                    <Input
                        autoFocus
                        placeholder="Nombre o Texto"
                        value={selectedKeys[0]}
                        onChange={(e: any) => {
                            setSelectedKeys(e.target.value ? [e.target.value] : []);
                            confirm({ closeDropdown: false });
                        }}
                        onPressEnter={() => {
                            confirm();
                        }}
                        onBlur={() => {
                            confirm();
                        }}
                    ></Input>
                );
            },
            filterIcon: () => {
                return <SearchOutlined />;
            },
            onFilter: (value: string, record: any) => {
                const searchWords = value.toLowerCase().split(' ');
                const searchText = record.comment?.originalText?.toLowerCase();
                return searchWords.every((word) => searchText && searchText.includes(word)) || record.reviewerDisplayName.toLowerCase().includes(value.toLowerCase());
            },
            /*sorter: (a: any, b: any) => moment(b.createdTime) > moment(a.createdTime),*/
            render: (text: string, record: any) => {
                
                const maxLength = 100;
                const truncatedText = !!record.comment.originalText && record.comment.originalText.length > maxLength ? record.comment.originalText.slice(0, maxLength) + '...' : record.comment.originalText;

                const hasMedia = record.reviewMediaItems && record.reviewMediaItems?.length > 0;
                const mediaCount = hasMedia ? record.reviewMediaItems?.length : 0;
                const { Icon, color, tooltip, background, replyScope } = getReviewStatus(record);
                return (
                    <div style={{margin: '15px 0px'}}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '0px' }}>
                            <img src={record.reviewerProfilePhotoUrl} style={{ width: '30px' }} />
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <span style={{ fontWeight: 500 }}>{record.reviewerDisplayName}</span>
                                    {hasMedia && (
                                        <Tooltip title={`${mediaCount} archivos multimedia`}>
                                            <Badge 
                                                count={mediaCount} 
                                                size="small" 
                                                style={{ backgroundColor: 'slategrey', fontSize: '10px' }}
                                                offset={[5, 0]}
                                            >
                                                <CameraOutlined style={{ color: '#8c8c8c', fontSize: '14px' }} />
                                            </Badge>
                                        </Tooltip>
                                    )}
                                </div>
                                <div style={{ fontSize: '10px', color: 'slategrey'}}>
                                    <Tooltip title={<>
                                                <div>Creada el {moment(record.createdTime).format('ll')}</div>
                                                {!moment(record.createdTime).isSame(moment(record.updateTime)) && <div>Actualizada el {moment(record.updateTime).format('ll')}</div>}
                                            </>}>
                                        <div style={{ fontSize: '10px', color: 'slategrey', textAlign:'right'}}>
                                            <div>Creada {moment(record.createdTime).fromNow()}</div>
                                            <div>{!moment(record.createdTime).isSame(moment(record.updateTime)) && <div>Actualizada {moment(record.updateTime).fromNow()}</div>}</div>
                                        </div>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                        
                        <div style={{ background:'#fdfdfd', padding:'4px 12px', margin:'3px 0px', borderRight:'2px solid ' + color}}>
                            <p style={{ color: 'var(--grey)', fontSize: 12 }}>{truncatedText}</p>
                            <div style={{display: 'flex', justifyContent: 'end', alignItems: 'center'}}>
                                <small style={{
                                    color: color,
                                    fontWeight: 500,
                                    background: background,
                                    padding: '3px 12px',
                                    borderRadius: '12px',
                                    border: '1px solid #dbe2f5',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: replyScope ? 12 : 0,
                                    minHeight: '26px'
                                }}>                                    
                                    {replyScope && (
                                        <span style={{
                                            background: '#f1f3fa',
                                            color: 'slategrey',
                                            fontWeight: 500,
                                            fontSize: '11px',
                                            borderRadius: '8px',
                                            padding: '1.5px 8px',
                                            marginLeft: 2,
                                            border: '1px solid #dbe2f5'
                                        }}>
                                            {replyScope}
                                        </span>
                                    )}
                                    <span>{tooltip}</span>  
                                </small>
                            </div>
                        </div>
                   
                        
                        {hasMedia && (
                            <div style={{ display: 'flex', gap: '4px', marginBottom: '8px' }}>
                                {record.reviewMediaItems.slice(0, 3).map((media: any, i: number) => (
                                    <div key={i} style={{ position: 'relative', width: '36px', height: '36px' }}>
                                        <img 
                                            src={media.thumbnailUrl} 
                                            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '4px', border: '1px solid #f0f0f0' }} 
                                        />
                                        {media.videoUrl && <PlayCircleOutlined style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', color: '#fff', fontSize: '12px' }} />}
                                    </div>
                                ))}
                                {mediaCount > 3 && <div style={{ fontSize: '10px', alignSelf: 'center', color: '#999' }}>+{mediaCount - 3}</div>}
                            </div>
                        )}
                        <small>{record.commentLabels ? 
                            record.commentLabels?.map((label: any) => {
                                return <Label reviewId={record.name} label={label} light={true} onChange={() => onLabelchange()}/>
                        })
                        :
                        <small style={{color:'slategrey'}}>Sin etiquetar</small>
                        }</small>      
                                          
                    </div>
                );
            }
        },        
        {
            title: '',
            key: 'locality',
            width: '150px',
            dataIndex: 'locality',
            filters: [
                { text: 'Respuesta Manual', value: 'MANUAL' },
                { text: 'Respuesta Automática', value: 'AUTOMATED' },
                { text: 'Respuesta sincronizada de Google', value: 'SYNC' },
                { text: <span style={{color: 'grey'}}>Sin clasificar</span>, value: null },
            ],
            onFilter: (value: any, record: any) => {
                return (
                    record.replyScope === value
                );
            },                   
            render: (text: string, record: any) => (                
                <LocationCardCompacted location={record}/>                                    
            )
        },
   
    ]

    const [selectedRowKey, setSelectedRowKey] = useState(null);

    const onSelectRow = (record: { name: any; }) => {
        //console.log('onSelectRow() ' + record.name);
        handleReviewClick(record)
        const rowKey = record.name;
        setSelectedRowKey(rowKey);
    };

    const rowClassName = (record: { name: null; }) => {
        return record.name === selectedRowKey ? 'selected-row' : '';
    };

    return (

        <div style={{ width: width }}>
            {/*<div style={{ color: 'grey', font: '26px' }}>{`${filteredRows} de ${reviewsData?.length}`}</div>*/}            

            <TableLZM size='small'
                rowClassName={rowClassName}
                //pagination={{ defaultPageSize: 100}}                
                pagination={false} 
                isLoading={isLoading}
                onRow={(record: { name: any; }) => ({
                    onClick: () => onSelectRow(record),
                    style: { cursor: 'pointer' },
                })} 
                columns={columns} 
                dataSource={reviewsData}
                rowKey="name"
                scroll={{ y: 600 }}
                /*onChange={(pagination: any, filters: any, sorter: any, extra: any) => {
                    setFilteredRows(extra?.currentDataSource?.length);
                    if(filters.text == null && filters.locality == null && filters.reviewReplyComment == null && filters.starRating == null){
                        setFilteredRows(reviewsData.length)
                    }
                }}*/
            />

        </div>
    )
}

export default Reviews;